import React from 'react';
import { View, StyleSheet } from 'react-native';
import { SkiaCanvas } from '../SkiaCanvas';

interface HandwritingCanvasPanelProps {
    readOnly?: boolean;
}

/**
 * Thin wrapper over SkiaCanvas for the handwriting input modality.
 *
 * Extracted from MultiModalInputArea so it can be independently tested
 * and reused across activities.
 */
export const HandwritingCanvasPanel: React.FC<HandwritingCanvasPanelProps> = ({
    readOnly = false,
}) => {
    return (
        <View style={[styles.panel, styles.canvasPanel]}
            accessibilityRole="image"
            accessibilityLabel={readOnly ? 'Read-only handwriting canvas' : 'Handwriting canvas for writing'}
        >
            <SkiaCanvas readOnly={readOnly} />
        </View>
    );
};

const styles = StyleSheet.create({
    panel: {
        // flexGrow + flexBasis 'auto' (not flex:1): fills bounded parents but
        // sizes to content inside indefinite-height containers, where a
        // zero-basis flex would collapse to 0 height under Yoga.
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 'auto',
        padding: 16,
        justifyContent: 'center',
    },
    canvasPanel: {
        padding: 0,
        justifyContent: 'flex-start',
        // The canvas has ~0 intrinsic height; floor it so it stays usable
        // when the parent height is indefinite (scrollable/auto-height card).
        minHeight: 200,
    },
});
